import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';
import { compose } from 'redux';
import { Field, reduxForm } from 'redux-form';
import { Card } from 'reactstrap';
import RenderFormInput from 'components/forms/RenderFormInput';
import { withRouter } from 'react-router-dom';
import Button from 'components/buttons/Button';
import LoadingIcon from 'mdi-react/LoadingIcon';
import { requiredValidator, handleBlur } from 'utils/validators';
import Error from 'components/forms/Error';

const styles = theme => ({
  wrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    width: '100%',
    backgroundColor: theme.palette.secondary.background,
  },
  card: {
    padding: '1rem',
    width: '450px',
  },
  title: {
    fontWeight: 'bold',
    textAlign: 'center',
  },
  submitBtn: {
    marginTop: '1rem',
  },
  recoveryEmailText: {
    color: theme.palette.primary.main,
  },
});

class ForgotPassword extends React.Component {
  static propTypes = {
    loading: PropTypes.bool.isRequired,
    onFormSubmit: PropTypes.func.isRequired,
    history: PropTypes.shape({
      push: PropTypes.func.isRequired,
    }).isRequired,
    handleSubmit: PropTypes.func.isRequired,
    classes: PropTypes.element.isRequired,
    submitting: PropTypes.bool,
    pristine: PropTypes.bool,
    error: PropTypes.string,
  }

  static defaultProps = {
    submitting: false,
    pristine: true,
    error: null,
  }

  constructor(props) {
    super(props);
    this.state = {
      showForm: true,
    };
  }

  handleChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }

  handleOnFormSubmit = (data) => {
    const { onFormSubmit } = this.props;
    onFormSubmit(data).then(() => this.setState({ showForm: false }));
  }

  render() {
    const {
      classes, loading, error, handleSubmit,
      pristine, submitting,
    } = this.props;
    const { showForm } = this.state;

    // Loading
    if (loading) return <div className="loader"><LoadingIcon /></div>;

    return (
      <div className={classes.wrapper}>
        {showForm ?
          <Card className={classes.card}>
            <h2 className={classes.title}>New password</h2>
            <form onSubmit={handleSubmit(this.handleOnFormSubmit)}>
              <div className="instance-form__body">
                {/* eslint-disable jsx-a11y/label-has-for */}
                <label htmlFor="delayBeforeEmail">Enter your account email</label>
                <Field
                  name="email"
                  component={RenderFormInput}
                  type="email"
                  placeholder="Recovery Email"
                  onBlur={handleBlur}
                  validate={[requiredValidator]}
                />
                <div>
                  <Error error={error} />
                </div>
                <Button
                  color="primary"
                  variant="contained"
                  type="submit"
                  fullWidth
                  className={classes.submitBtn}
                  disabled={pristine || submitting}
                >
                  Send recovery email
                </Button>
              </div>
            </form>
          </Card>
          :
          <div className={classes.recoveryEmailText}>A recovery email has been sent.</div>
        }
      </div>
    );
  }
}

export default compose(
  withStyles(styles),
  withRouter,
  reduxForm({
    form: 'forgot_password_form',
  }),
)(ForgotPassword);
